import { HgSupportedLanguage, SupportedPlatforms } from '@smg-real-estate/domus';
import { type I18n } from 'vue-i18n';
import {
  createRouter as _createRouter,
  createMemoryHistory,
  createWebHistory,
  type Router,
} from 'vue-router';

import { setLocaleBeforeRouteChange } from '@/i18n/setup/i18nSetup';
import { getDetailPageRoutes } from '@/router/homepageRoute';
import { loginCallBackRoute } from '@/router/loginCallBackPageRoute';
import { loadAdsScripts } from '@smg-real-estate/ads-lib';
import { setupRumViewTracking } from '@smg-real-estate/browser-rum/vue';
import { contactRequestEmailVerificationRoute } from './contactRequestEmailVerificationRoute';
import { listingPreviewRoutes } from './listingPreviewRoute';
import { notFoundRoutes } from './notFoundRoute';

export function getAllRoutes() {
  return [
    ...getDetailPageRoutes(),
    ...listingPreviewRoutes(),
    ...loginCallBackRoute(),
    ...contactRequestEmailVerificationRoute(),
    ...notFoundRoutes(),
  ];
}

export const createRouter = (): Router => {
  // We need base only when building the app
  const basePath = import.meta.env.MODE === 'production' ? import.meta.env.VUE_BASE_PATH : '/';
  return _createRouter({
    history: import.meta.env.SSR ? createMemoryHistory(basePath) : createWebHistory(basePath),
    routes: getAllRoutes(),
  });
};

export function initGuards(router: Router, i18n: I18n) {
  router.beforeEach(async (to, _from, next) => {
    const locale = (to.params.locale || to?.meta?.locale) as HgSupportedLanguage;

    await setLocaleBeforeRouteChange(i18n, locale);

    if (typeof window !== 'undefined' && to.name?.toString().toLowerCase().includes('detailpage')) {
      loadAdsScripts(import.meta.env.VUE_APP_PLATFORM as SupportedPlatforms, true);
    }

    next();
  });

  setupRumViewTracking(router);
}
